///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2023
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { division, graphTypesV2 } from "./types";
import messages from "./messages";

export const graphOptions = [
  {
    value: graphTypesV2.costOverTime,
    yAxisDataKey: "averageCost",
    yAxisName: messages.avgCost.defaultMessage,
    label: messages.costOverTime.defaultMessage,
    heading: messages.costOverTime.defaultMessage
  },
  {
    value: graphTypesV2.cpmOverTime,
    yAxisDataKey: "averageCpm",
    [division.coy]: {
      label: messages.cpmOverTime.defaultMessage,
      yAxisName: messages.avgCpm.defaultMessage,
      heading: messages.cpmOverTime.defaultMessage
    },
    [division.eu]: {
      label: messages.cpKmOverTime.defaultMessage,
      yAxisName: messages.avgCpKm.defaultMessage,
      heading: messages.cpKmOverTime.defaultMessage
    }
  },
  {
    value: graphTypesV2.costFrequency,
    xAxisDataKey: "averageCost",
    label: messages.costFrequency.defaultMessage,
    xAxisName: messages.avgCost.defaultMessage,
    heading: messages.historicalVolumeByCost.defaultMessage
  },
  {
    value: graphTypesV2.cpmFrequency,
    xAxisDataKey: "averageCpm",
    [division.coy]: {
      label: messages.cpmFrequency.defaultMessage,
      xAxisName: messages.avgCpm.defaultMessage,
      heading: messages.historicalVolumeByCPM.defaultMessage
    },
    [division.eu]: {
      label: messages.cpKmFrequency.defaultMessage,
      xAxisName: messages.avgCpKm.defaultMessage,
      heading: messages.historicalVolumeByCPKm.defaultMessage
    }
  }
];

export const getAnalyticsGraphOptions = userDivision =>
  graphOptions.map(o => ({ ...o, ...o[userDivision] }));

export default getAnalyticsGraphOptions;
